import getStore from '../store/store';
import { createDisplayDate } from 'owa-datetime';
import { mutator } from 'satcheljs';
import setEndTime from '../../actions/setEndTime';
import getEndDateAfterModifications from '../../utils/getEndDateAfterModifications';
/**
 * Function to mutate the end time.
 */
export default mutator(setEndTime, function (actionMessage) {
    var date = actionMessage.dateTime;
    var optionState = getStore().currentState;
    var intialState = getStore().initialState;
    if (optionState.endDate) {
        var curEnd = optionState.endDate;
        var endHours = date.getHours();
        var endMinutes = date.getMinutes();
        var endYear = curEnd.getFullYear();
        var endMonth = curEnd.getMonth();
        var endDate = curEnd.getDate();
        // Set new end
        var newEnd = createDisplayDate(endYear, endMonth, endDate, endHours, endMinutes);
        optionState.endDate = newEnd;
    }
    else {
        var initialEnd = intialState.endDate;
        var endHours = date.getHours();
        var endMinutes = date.getMinutes();
        var endYear = initialEnd.getFullYear();
        var endMonth = initialEnd.getMonth();
        var endDate = initialEnd.getDate();
        // Set new end
        var newEnd = createDisplayDate(endYear, endMonth, endDate, endHours, endMinutes);
        optionState.endDate = newEnd;
    }
    optionState.endDate = getEndDateAfterModifications();
});
//# sourceMappingURL=setEndTime.js.map